export type { Contacts } from './config';
export { contactApi } from './api/contactApi';
export { useContactsData, contactsPageQueryKeys } from './model';
